import * as React from 'react';

import type { IconProps } from './types';

export const FolderPackage = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      fill="none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g fill={color}>
        <path
          d="M6.404 1.35h1.402c.594 0 1.098 0 1.52.043.446.043.86.139 1.256.37.396.23.685.54.945.906.244.345.495.783.789 1.299l.321.561c.105.193.219.381.34.564.024.035.05.068.08.098h.003l.012.004a.68.68 0 0 0 .111.018c.14.014.327.015.657.015h1.544c1.514 0 2.736 0 3.696.128.997.135 1.836.421 2.503 1.089.667.666.954 1.506 1.087 2.502.107.79.126 1.758.13 2.918l-3.908-2.33a2.713 2.713 0 0 0-2.785 0l-5 2.982-.226.163c-.714.513-.714.513-.714 1.542v5.452c0 .989.514 1.904 1.353 2.406l1.453.87H8.616c-1.514 0-2.736 0-3.696-.129-.997-.133-1.837-.42-2.503-1.087-.667-.667-.954-1.506-1.087-2.503-.13-.96-.13-2.182-.13-3.696v-8.98c0-.996 0-1.825.089-2.484.093-.696.3-1.324.804-1.828s1.131-.71 1.827-.804c.66-.088 1.488-.088 2.484-.088z"
          fill={color}
        />

        <path
          d="m13.015 20.848 3.763 2.254a.34.34 0 0 0 .47-.123.354.354 0 0 0 .048-.178v-4.497c0-.495-.258-.953-.678-1.204l-4.1-2.447a.34.34 0 0 0-.47.124.353.353 0 0 0-.048.177v4.09c0 .74.386 1.427 1.015 1.804zm4.689-2.546v4.5c0 .192.154.348.343.348a.34.34 0 0 0 .175-.048l3.764-2.257A2.102 2.102 0 0 0 23 19.041v-4.098a.347.347 0 0 0-.344-.349.34.34 0 0 0-.174.049l-4.102 2.456c-.419.251-.676.709-.676 1.203zm-1.249-6.863-3.75 2.237a.352.352 0 0 0 0 .602l4.097 2.445c.43.257.964.257 1.395-.001l4.09-2.45a.352.352 0 0 0-.001-.602l-3.742-2.231a2.035 2.035 0 0 0-2.089 0z"
          fill={color}
        />
      </g>
    </svg>
  )
);

export default FolderPackage;
